export const GENDER_TYPES = Object.freeze({
 MALE: "MALE",
 FEMALE: "FEMALE",
});
